import { ResourceTypeSlug } from "@twinkltech/curriculum-architect-domain-hooks";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getResourceTypeDisplayLabel = ({
  displayLabel,
  slug,
}: {
  displayLabel?: string;
  slug?: ResourceTypeSlug | null;
}) => {
  if (displayLabel) {
    return displayLabel;
  }

  if (!slug) {
    return i18n.t("resources.types.no-type", { ns: COMMON_NS });
  }

  switch (slug) {
    case "sixty-second-read":
      return i18n.t("resources.types.sixty-second-read", { ns: COMMON_NS });
    case "activity-cards":
      return i18n.t("resources.types.activity-cards", { ns: COMMON_NS });
    case "activity-mat":
      return i18n.t("resources.types.activity-mat", { ns: COMMON_NS });
    case "activity-pack":
      return i18n.t("resources.types.activity-pack", { ns: COMMON_NS });
    case "activity-planning-and-continuous-provision-ideas":
      return i18n.t(
        "resources.types.activity-planning-and-continuous-provision-ideas",
        { ns: COMMON_NS }
      );
    case "activity-planning-and-continuous-provision-ideas-resource-pack":
      return i18n.t(
        "resources.types.activity-planning-and-continuous-provision-ideas-resource-pack",
        { ns: COMMON_NS }
      );
    case "activity-sheet":
      return i18n.t("resources.types.activity-sheet", { ns: COMMON_NS });
    case "adult-input-plan":
      return i18n.t("resources.types.adult-input-plan", { ns: COMMON_NS });
    case "app-game":
      return i18n.t("resources.types.app-game", { ns: COMMON_NS });
    case "area-plan":
      return i18n.t("resources.types.area-plan", { ns: COMMON_NS });
    case "assessment-pack":
      return i18n.t("resources.types.assessment-pack", { ns: COMMON_NS });
    case "assessment-rubric":
      return i18n.t("resources.types.assessment-rubric", { ns: COMMON_NS });
    case "assessment-sheet":
      return i18n.t("resources.types.assessment-sheet", { ns: COMMON_NS });
    case "assessment-spreadsheet":
      return i18n.t("resources.types.assessment-spreadsheet", {
        ns: COMMON_NS,
      });
    case "assessment-tracker":
      return i18n.t("resources.types.assessment-tracker", { ns: COMMON_NS });
    case "badges":
      return i18n.t("resources.types.badges", { ns: COMMON_NS });
    case "bingo":
      return i18n.t("resources.types.bingo", { ns: COMMON_NS });
    case "board-game":
      return i18n.t("resources.types.board-game", { ns: COMMON_NS });
    case "book-cover":
      return i18n.t("resources.types.book-cover", { ns: COMMON_NS });
    case "booklet":
      return i18n.t("resources.types.booklet", { ns: COMMON_NS });
    case "bookmarks":
      return i18n.t("resources.types.bookmarks", { ns: COMMON_NS });
    case "calendar":
      return i18n.t("resources.types.calendar", { ns: COMMON_NS });
    case "certificate":
      return i18n.t("resources.types.certificate", { ns: COMMON_NS });
    case "challenge-cards":
      return i18n.t("resources.types.challenge-cards", { ns: COMMON_NS });
    case "colouring-page":
      return i18n.t("resources.types.colouring-page", { ns: COMMON_NS });
    case "composable-audio-ebook":
      return i18n.t("resources.types.composable-audio-ebook", {
        ns: COMMON_NS,
      });
    case "composable-bingo":
      return i18n.t("resources.types.composable-bingo", { ns: COMMON_NS });
    case "composable-hotspots":
      return i18n.t("resources.types.composable-hotspots", { ns: COMMON_NS });
    case "composable-matching-activity":
      return i18n.t("resources.types.composable-matching-activity", {
        ns: COMMON_NS,
      });
    case "composable-multiple-choice-quiz":
      return i18n.t("resources.types.composable-multiple-choice-quiz", {
        ns: COMMON_NS,
      });
    case "composable-puzzle-strips":
      return i18n.t("resources.types.composable-puzzle-strips", {
        ns: COMMON_NS,
      });
    case "composable-reading-comprehension":
      return i18n.t("resources.types.composable-reading-comprehension", {
        ns: COMMON_NS,
      });
    case "composable-sorting-activity":
      return i18n.t("resources.types.composable-sorting-activity", {
        ns: COMMON_NS,
      });
    case "composable-word-cards":
      return i18n.t("resources.types.composable-word-cards", { ns: COMMON_NS });
    case "composable-word-guess-game":
      return i18n.t("resources.types.composable-word-guess-game", {
        ns: COMMON_NS,
      });
    case "composable-word-mat-activity":
      return i18n.t("resources.types.composable-word-mat-activity", {
        ns: COMMON_NS,
      });
    case "composable-word-search":
      return i18n.t("resources.types.composable-word-search", {
        ns: COMMON_NS,
      });
    case "continuous-provision-planning-ideas":
      return i18n.t("resources.types.continuous-provision-planning-ideas", {
        ns: COMMON_NS,
      });
    case "craft-instructions":
      return i18n.t("resources.types.craft-instructions", { ns: COMMON_NS });
    case "crossword":
      return i18n.t("resources.types.crossword", { ns: COMMON_NS });
    case "cut-out":
      return i18n.t("resources.types.cut-out", { ns: COMMON_NS });
    case "discussion-cards":
      return i18n.t("resources.types.discussion-cards", { ns: COMMON_NS });
    case "display-banner":
      return i18n.t("resources.types.display-banner", { ns: COMMON_NS });
    case "display-borders":
      return i18n.t("resources.types.display-borders", { ns: COMMON_NS });
    case "display-bunting":
      return i18n.t("resources.types.display-bunting", { ns: COMMON_NS });
    case "display-lettering":
      return i18n.t("resources.types.display-lettering", { ns: COMMON_NS });
    case "display-photos":
      return i18n.t("resources.types.display-photos", { ns: COMMON_NS });
    case "display-timeline":
      return i18n.t("resources.types.display-timeline", { ns: COMMON_NS });
    case "dot-to-dot":
      return i18n.t("resources.types.dot-to-dot", { ns: COMMON_NS });
    case "ebook":
      return i18n.t("resources.types.ebook", { ns: COMMON_NS });
    case "fact-cards":
      return i18n.t("resources.types.fact-cards", { ns: COMMON_NS });
    case "fact-file":
      return i18n.t("resources.types.fact-file", { ns: COMMON_NS });
    case "flashcards":
      return i18n.t("resources.types.flashcards", { ns: COMMON_NS });
    case "glossary":
      return i18n.t("resources.types.glossary", { ns: COMMON_NS });
    case "greetings-cards":
      return i18n.t("resources.types.greetings-cards", { ns: COMMON_NS });
    case "grid":
      return i18n.t("resources.types.grid", { ns: COMMON_NS });
    case "guidance":
      return i18n.t("resources.types.guidance", { ns: COMMON_NS });
    case "guide":
      return i18n.t("resources.types.guide", { ns: COMMON_NS });
    case "home-learning-task":
      return i18n.t("resources.types.home-learning-task", { ns: COMMON_NS });
    case "instructions":
      return i18n.t("resources.types.instructions", { ns: COMMON_NS });
    case "interactive-game":
      return i18n.t("resources.types.interactive-game", { ns: COMMON_NS });
    case "interactive-pdf-activity":
      return i18n.t("resources.types.interactive-pdf-activity", {
        ns: COMMON_NS,
      });
    case "interactive-word-search":
      return i18n.t("resources.types.interactive-word-search", {
        ns: COMMON_NS,
      });
    case "knowledge-organiser":
      return i18n.t("resources.types.knowledge-organiser", { ns: COMMON_NS });
    case "labels":
      return i18n.t("resources.types.labels", { ns: COMMON_NS });
    case "lanyard-inserts":
      return i18n.t("resources.types.lanyard-inserts", { ns: COMMON_NS });
    case "large-activity-tray":
      return i18n.t("resources.types.large-activity-tray", { ns: COMMON_NS });
    case "leaflet":
      return i18n.t("resources.types.leaflet", { ns: COMMON_NS });
    case "lesson-pack":
      return i18n.t("resources.types.lesson-pack", { ns: COMMON_NS });
    case "lesson-plan":
      return i18n.t("resources.types.lesson-plan", { ns: COMMON_NS });
    case "letter-template":
      return i18n.t("resources.types.letter-template", { ns: COMMON_NS });
    case "loop-cards":
      return i18n.t("resources.types.loop-cards", { ns: COMMON_NS });
    case "map":
      return i18n.t("resources.types.map", { ns: COMMON_NS });
    case "matching-cards":
      return i18n.t("resources.types.matching-cards", { ns: COMMON_NS });
    case "mini-book":
      return i18n.t("resources.types.mini-book", { ns: COMMON_NS });
    case "numeracy-assessment":
      return i18n.t("resources.types.numeracy-assessment", { ns: COMMON_NS });
    case "page-borders":
      return i18n.t("resources.types.page-borders", { ns: COMMON_NS });
    case "planning-overview":
      return i18n.t("resources.types.planning-overview", { ns: COMMON_NS });
    case "playdough-mat":
      return i18n.t("resources.types.playdough-mat", { ns: COMMON_NS });
    case "poem":
      return i18n.t("resources.types.poem", { ns: COMMON_NS });
    case "poster":
      return i18n.t("resources.types.poster", { ns: COMMON_NS });
    case "powerpoint":
      return i18n.t("resources.types.powerpoint", { ns: COMMON_NS });
    case "powerpoint-game":
      return i18n.t("resources.types.powerpoint-game", { ns: COMMON_NS });
    case "progression-overview":
      return i18n.t("resources.types.progression-overview", { ns: COMMON_NS });
    case "puzzle":
      return i18n.t("resources.types.puzzle", { ns: COMMON_NS });
    case "quiz":
      return i18n.t("resources.types.quiz", { ns: COMMON_NS });
    case "reading-comprehension":
      return i18n.t("resources.types.reading-comprehension", { ns: COMMON_NS });
    case "reasoning-cards":
      return i18n.t("resources.types.reasoning-cards", { ns: COMMON_NS });
    case "recipe":
      return i18n.t("resources.types.recipe", { ns: COMMON_NS });
    case "reward-charts":
      return i18n.t("resources.types.reward-charts", { ns: COMMON_NS });
    case "script":
      return i18n.t("resources.types.script", { ns: COMMON_NS });
    case "sensory-activity":
      return i18n.t("resources.types.sensory-activity", { ns: COMMON_NS });
    case "sheet-music":
      return i18n.t("resources.types.sheet-music", { ns: COMMON_NS });
    case "stickers":
      return i18n.t("resources.types.stickers", { ns: COMMON_NS });
    case "story":
      return i18n.t("resources.types.story", { ns: COMMON_NS });
    case "success-criteria-grids":
      return i18n.t("resources.types.success-criteria-grids", {
        ns: COMMON_NS,
      });
    case "table-signs":
      return i18n.t("resources.types.table-signs", { ns: COMMON_NS });
    case "teaching-ideas":
      return i18n.t("resources.types.teaching-ideas", { ns: COMMON_NS });
    case "term-planner":
      return i18n.t("resources.types.term-planner", { ns: COMMON_NS });
    case "test":
      return i18n.t("resources.types.test", { ns: COMMON_NS });
    case "timetable":
      return i18n.t("resources.types.timetable", { ns: COMMON_NS });
    case "topic-web":
      return i18n.t("resources.types.topic-web", { ns: COMMON_NS });
    case "unit-pack":
      return i18n.t("resources.types.unit-pack", { ns: COMMON_NS });
    case "video":
      return i18n.t("resources.types.video", { ns: COMMON_NS });
    case "word-cards":
      return i18n.t("resources.types.word-cards", { ns: COMMON_NS });
    case "word-search":
      return i18n.t("resources.types.word-search", { ns: COMMON_NS });
    case "writing-frames":
      return i18n.t("resources.types.writing-frames", { ns: COMMON_NS });
    case "test-dev":
      return i18n.t("resources.types.test-dev", { ns: COMMON_NS });
    default:
      return i18n.t("resources.types.label-not-found", { slug, ns: COMMON_NS });
  }
};
